var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWally(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1249,
    height: 395,
    viewBox: "0 0 1249 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.557 350.925H133.073L164.134 0H234.882L263.887 350.925H275.402V0H396.959L330.364 394.098H232.826L198.48 164.8L164.134 394.098H66.595L0 0H121.557V350.925ZM626.775 394.098H504.149L525.162 298.239H471.229L492.239 394.098H369.616L435.853 0H560.577L626.775 394.098ZM740.654 350.925H752.286L802.658 298.2H817.735V394.098H653.68L649.328 0H746.272L740.654 350.925ZM936.723 350.925H948.356L998.768 298.2H1013.84V394.098H849.749L845.397 0H942.34L936.722 350.925H936.723ZM1073.93 0L1103.88 212.529H1115.12L1145.07 0H1248.74L1154.53 255.464L1158.29 394.098H1060.71L1064.47 255.464L970.255 0H1073.93ZM471.229 256.89H525.162L503.794 41.864H492.596L471.229 256.89Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWally);
export default __webpack_public_path__ + "static/media/wally.aa0eb7380615e52284ef411ce581d42a.svg";
export { ForwardRef as ReactComponent };